import { render } from "./slide5.vue?vue&type=template&id=4ef81c8d&scoped=true"
import script from "./slide5.vue?vue&type=script&lang=js"
export * from "./slide5.vue?vue&type=script&lang=js"

import "./slide5.vue?vue&type=style&index=0&id=4ef81c8d&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef81c8d"]])

export default __exports__